import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "auth-oauth" }
const _hoisted_2 = {
  key: 0,
  class: "auth-gosuslugi"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 220 34.7" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#EE3F58",
    d: "M143.6.8h-18c-.2 0-.3.1-.3.3-.5 8.1-2 16.9-4.2 24v.3c.1.1.2.1.3.1h6.2c.1 0 .3-.1.3-.2 1.7-5.5 3.1-12.7 3.6-18.8h5.9v18.7c0 .2.1.3.3.3h5.9c.2 0 .3-.1.3-.3v-24c0-.2-.1-.4-.3-.4M219.7.8h-5.9c-.2 0-.3.1-.3.3v18.6c-1.3.4-2.6.5-4 .5-3.9 0-4.8-1.2-4.8-6.4V1.2c0-.2-.1-.3-.3-.3h-5.9c-.2 0-.3.1-.3.3v13.4c0 8.4 2.8 11.7 10.1 11.7 4.1 0 8.8-1.1 11.5-2.1.1 0 .2-.2.2-.3V1.2c0-.2-.1-.4-.3-.4M95.2.9h-6c-.2 0-.3.1-.3.2-.9 3.7-2.8 9.9-5.4 16.4L77.5 1c0-.1-.2-.2-.3-.2h-6c-.1 0-.2.1-.3.1-.1.1-.1.2 0 .3l9 24.6c-.9 1.9-1.8 3.5-2.6 5-.6 1.1-1.2 2.2-1.8 3.4-.1.1 0 .2 0 .3.1.1.2.2.3.2h6.5c.1 0 .2-.1.3-.2 1.1-2.1 2.5-5.1 3.8-8.1 3.8-9 6.9-17.4 9.2-25.1 0-.1 0-.2-.1-.3-.1-.1-.2-.1-.3-.1M116.6 19.8c0-.1-.1-.2-.2-.2h-.3c-1.4.5-4.1 1-6 1-4.1 0-6-1.1-6-7.4 0-5 .6-7.4 6-7.4 1.5 0 3 .2 4.8.8.2 0 .3 0 .4-.2.7-1.3 1.5-2.8 2.4-4.8v-.3c0-.1-.1-.2-.2-.2-2.4-.8-5.3-1.2-7.8-1.2-8.6 0-12.4 4-12.4 13.1 0 9.2 3.8 13.3 12.4 13.3 2.1 0 6.4-.5 8.4-1.3.2-.1.2-.2.2-.4l-1.7-4.8zM172.5.9h-6c-.1 0-.3.1-.3.2-.9 3.7-2.8 9.9-5.4 16.4l-6-16.5c0-.1-.2-.2-.3-.2h-6c-.1 0-.2.1-.3.1-.1.1-.1.2 0 .3l9 24.6c-.9 1.9-1.8 3.4-2.6 5-.6 1.1-1.2 2.2-1.8 3.4-.1.1 0 .2 0 .3.1.1.2.2.3.2h6.5c.1 0 .2-.1.3-.2 1.1-2.1 2.5-5.1 3.8-8.1 3.8-9 6.9-17.4 9.1-25.1 0-.1 0-.2-.1-.3 0-.1-.1-.1-.2-.1M194.5.8h-17.4c-.2 0-.3.1-.3.3v24.1c0 .2.1.3.3.3h5.9c.2 0 .3-.1.3-.3V6.6h9.1c.1 0 .3-.1.3-.2.7-1.6 1.4-3.4 2.1-5.1V1c-.1-.1-.2-.2-.3-.2"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#0065B1",
    d: "M31.3 20.8c-3.9 0-5.1-1.1-5.1-7.6 0-7 1.3-7.6 5.1-7.6s5.2.6 5.2 7.6c0 6.6-1.3 7.6-5.2 7.6m0-20.7c-8.5 0-11.8 3.6-11.8 13 0 9.5 3.3 13.2 11.8 13.2s11.9-3.7 11.9-13.2c0-9.3-3.4-13-11.9-13M66.6 19.8c0-.1-.1-.2-.2-.2h-.3c-1.4.5-4.1 1-6 1-4.1 0-6-1.1-6-7.4 0-5 .6-7.4 6-7.4 1.5 0 3 .2 4.8.8.1 0 .3 0 .4-.2.7-1.3 1.5-2.8 2.4-4.8v-.3c0-.1-.1-.2-.2-.2C65.2.4 62.3 0 59.8 0c-8.6 0-12.4 4-12.4 13.1 0 9.2 3.8 13.3 12.4 13.3 2.1 0 6.4-.5 8.4-1.3.2-.1.2-.2.2-.4l-1.8-4.9zM17.7.8H.3C.1.8 0 1 0 1.2v24.1c0 .2.1.3.3.3h5.9c.2 0 .3-.1.3-.3V6.6h9.1c.1 0 .2-.1.3-.2.7-1.6 1.4-3.4 2.1-5.1V1c-.1-.1-.2-.2-.3-.2"
  })
], -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "auth-social"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  "enable-background": "new 0 0 24 24",
  height: "512",
  viewBox: "0 0 24 24",
  width: "512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "m19.915 13.028c-.388-.49-.277-.708 0-1.146.005-.005 3.208-4.431 3.538-5.932l.002-.001c.164-.547 0-.949-.793-.949h-2.624c-.668 0-.976.345-1.141.731 0 0-1.336 3.198-3.226 5.271-.61.599-.892.791-1.225.791-.164 0-.419-.192-.419-.739v-5.105c0-.656-.187-.949-.74-.949h-4.126c-.419 0-.668.306-.668.591 0 .622.945.765 1.043 2.515v3.797c0 .832-.151.985-.486.985-.892 0-3.057-3.211-4.34-6.886-.259-.713-.512-1.001-1.185-1.001h-2.625c-.749 0-.9.345-.9.731 0 .682.892 4.073 4.148 8.553 2.17 3.058 5.226 4.715 8.006 4.715 1.671 0 1.875-.368 1.875-1.001 0-2.922-.151-3.198.686-3.198.388 0 1.056.192 2.616 1.667 1.783 1.749 2.076 2.532 3.074 2.532h2.624c.748 0 1.127-.368.909-1.094-.499-1.527-3.871-4.668-4.023-4.878z",
    fill: "#4b729f"
  })
], -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  x: "0px",
  y: "0px",
  viewBox: "0 0 512 512",
  style: {"enable-background":"new 0 0 512 512"},
  "xml:space": "preserve"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("path", {
  d: "M288,176v-64c0-17.664,14.336-32,32-32h32V0h-64c-53.024,0-96,42.976-96,96v80h-64v80h64v256h96V256h64l32-80H288z",
  fill: "#3b5998"
}, null, -1 /* HOISTED */)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.6405 6.29377C10.992 5.94318 11.4768 5.72557 12.0101 5.72557C12.5555 5.72557 13.0282 5.94318 13.3797 6.29377C13.7311 6.64437 13.9493 7.12794 13.9493 7.65988C13.9493 8.20391 13.7311 8.6754 13.3797 9.02599C13.0282 9.37658 12.5434 9.59419 12.0101 9.59419C11.4647 9.59419 10.992 9.37658 10.6405 9.02599C10.2891 8.6754 10.0709 8.19182 10.0709 7.65988C10.0709 7.12794 10.3012 6.64437 10.6405 6.29377Z",
    fill: "#FF7700"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M1.67554 1.67638C9.53674e-07 3.36482 0 6.09045 0 11.5176V12.4824C0 17.9216 -7.15256e-07 20.6352 1.68759 22.3236C3.37519 24 6.09944 24 11.5238 24H12.4882C17.9126 24 20.6489 24 22.3245 22.3236C24 20.6352 24 17.9095 24 12.4824V11.5176C24 6.09045 24 3.35276 22.3245 1.67638C20.6369 0 17.9126 0 12.4882 0H11.5239C6.08739 0 3.37519 0 1.67554 1.67638ZM11.998 11.9154C13.1736 11.9154 14.2402 11.4318 15.0037 10.6702C15.7673 9.90852 16.2521 8.84465 16.2521 7.67197C16.2521 6.49929 15.7673 5.43542 15.0037 4.67379C14.2402 3.91215 13.1736 3.42857 11.998 3.42857C10.8223 3.42857 9.75577 3.91215 8.99221 4.67379C8.22865 5.42333 7.74384 6.4872 7.74384 7.67197C7.74384 8.85674 8.22865 9.90852 8.99221 10.6702C9.75577 11.4318 10.8345 11.9154 11.998 11.9154ZM17.7429 13.6321L16.4945 11.9275C16.4218 11.8308 16.2764 11.8187 16.1915 11.9033C15.0159 12.9067 13.5615 13.5596 11.998 13.5596C10.4345 13.5596 8.99222 12.9067 7.80445 11.9033C7.71961 11.8308 7.57417 11.8429 7.50145 11.9275L6.25309 13.6321C6.19249 13.7167 6.20461 13.8255 6.27733 13.8981C7.33177 14.7443 8.55589 15.3246 9.8285 15.6269L7.18633 20.2692C7.11361 20.4022 7.21057 20.5714 7.35601 20.5714H9.93758C10.0224 20.5714 10.0951 20.5231 10.1194 20.4385L11.9616 16.328L13.8039 20.4385C13.8281 20.511 13.9008 20.5714 13.9857 20.5714H16.5672C16.7248 20.5714 16.8096 20.4143 16.7369 20.2692L14.0948 15.6269C15.3674 15.3246 16.5915 14.7685 17.6459 13.8981C17.8035 13.8255 17.8156 13.7167 17.7429 13.6321Z",
    fill: "#FF7700"
  })
], -1 /* HOISTED */)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["href"]
const _hoisted_18 = {
  x: "0px",
  y: "0px",
  viewBox: "0 0 512 512",
  style: {"enable-background":"new 0 0 512 512"},
  "xml:space": "preserve"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#D7143A",
  d: "M363.493,0h-72.744C217.05,0,142.684,54.422,142.684,176.006c0,62.978,26.691,112.027,75.619,139.922l-89.552,162.091c-4.246,7.666-4.357,16.354-0.298,23.24c3.963,6.725,11.21,10.741,19.378,10.741h45.301c10.291,0,18.315-4.974,22.163-13.688L299.26,334.08h6.128v157.451c0,11.096,9.363,20.469,20.446,20.469h39.574c12.429,0,21.106-8.678,21.106-21.104V22.403C386.516,9.213,377.05,0,363.493,0z M305.388,261.126h-10.81c-41.915,0-66.938-34.214-66.938-91.523c0-71.259,31.61-96.648,61.194-96.648h16.554V261.126z"
}, null, -1 /* HOISTED */)
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($data.isEsia)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("a", {
            href: $options.makeService('esia_v2')
          }, _hoisted_5, 8 /* PROPS */, _hoisted_3)
        ]))
      : _createCommentVNode("v-if", true),
    ($data.isSocials)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          ($data.services.includes('vk'))
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: $options.makeService('vkontakte')
              }, _hoisted_9, 8 /* PROPS */, _hoisted_7))
            : _createCommentVNode("v-if", true),
          ($data.services.includes('facebook'))
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: $options.makeService('facebook')
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_11, _hoisted_13))
              ], 8 /* PROPS */, _hoisted_10))
            : _createCommentVNode("v-if", true),
          _createCommentVNode("            <a v-if=\"services.includes('google')\" :href=\"makeService('google_oauth')\">"),
          _createCommentVNode("                <svg x=\"0px\" y=\"0px\" viewBox=\"0 0 512 512\" style=\"enable-background:new 0 0 512 512;\""),
          _createCommentVNode("                     xml:space=\"preserve\">"),
          _createCommentVNode("                    <path fill=\"#FBBB00\""),
          _createCommentVNode("                          d=\"M113.47,309.408L95.648,375.94l-65.139,1.378C11.042,341.211,0,299.9,0,256c0-42.451,10.324-82.483,28.624-117.732h0.014l57.992,10.632l25.404,57.644c-5.317,15.501-8.215,32.141-8.215,49.456C103.821,274.792,107.225,292.797,113.47,309.408z\"></path>"),
          _createCommentVNode("                    <path fill=\"#518EF8\""),
          _createCommentVNode("                          d=\"M507.527,208.176C510.467,223.662,512,239.655,512,256c0,18.328-1.927,36.206-5.598,53.451c-12.462,58.683-45.025,109.925-90.134,146.187l-0.014-0.014l-73.044-3.727l-10.338-64.535c29.932-17.554,53.324-45.025,65.646-77.911h-136.89V208.176h138.887L507.527,208.176L507.527,208.176z\"></path>"),
          _createCommentVNode("                    <path fill=\"#28B446\""),
          _createCommentVNode("                          d=\"M416.253,455.624l0.014,0.014C372.396,490.901,316.666,512,256,512c-97.491,0-182.252-54.491-225.491-134.681l82.961-67.91c21.619,57.698,77.278,98.771,142.53,98.771c28.047,0,54.323-7.582,76.87-20.818L416.253,455.624z\"></path>"),
          _createCommentVNode("                    <path fill=\"#F14336\""),
          _createCommentVNode("                          d=\"M419.404,58.936l-82.933,67.896c-23.335-14.586-50.919-23.012-80.471-23.012c-66.729,0-123.429,42.957-143.965,102.724l-83.397-68.276h-0.014C71.23,56.123,157.06,0,256,0C318.115,0,375.068,22.126,419.404,58.936z\"></path>"),
          _createCommentVNode("                </svg>"),
          _createCommentVNode("            </a>"),
          ($data.services.includes('odnoklassniki'))
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                href: $options.makeService('odnoklassniki')
              }, _hoisted_16, 8 /* PROPS */, _hoisted_14))
            : _createCommentVNode("v-if", true),
          ($data.services.includes('yandex'))
            ? (_openBlock(), _createElementBlock("a", {
                key: 3,
                href: $options.makeService('yandex')
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_18, _hoisted_20))
              ], 8 /* PROPS */, _hoisted_17))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}